import { apiHttpClient } from "@/http/httpClient";
import type {
    ActivePlanRunResponse,
    CancelPlanRunResponse,
    PlanRunCheck,
    PlanRunSummary,
} from '@/models/plan-run/plan-run';

const ENDPOINT_START_PLAN_RUN = 'PlanRun/Start';
const ENDPOINT_GET_ACTIVE_PLAN_RUN = 'PlanRun/GetActive';
const ENDPOINT_GET_PLAN_RUN_SUMMARY = 'PlanRun/GetSummary';
const ENDPOINT_CHECK_PLAN_RUN = 'PlanRun/Check';
const ENDPOINT_CANCEL_PLAN_RUN = 'PlanRun/Cancel';

/** Start een automatische plan-run. Geeft het id van de plan-run terug. */
export const startPlanRun = async (trajectoryIds: number[], transportVehicleIds: number[], startDate: number) => {
    return await apiHttpClient().post<number>(ENDPOINT_START_PLAN_RUN, {
        trajectoryIds: trajectoryIds,
        transportVehicleIds: transportVehicleIds,
        startDate: startDate
    })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

/**
 * De plan-run-stand van de organisatie. Bewust zonder centrale foutafhandeling: de dagplanner pollt
 * hierop, en een falend endpoint zou anders elke paar seconden een foutmelding opleveren.
 */
export const getActivePlanRun = async () => {
    return await apiHttpClient(false).get<ActivePlanRunResponse>(ENDPOINT_GET_ACTIVE_PLAN_RUN)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

/**
 * De samenvatting van één run: wat er gepland is en wat er om welke reden bleef liggen. Bewust een eigen
 * opvraging en niet meeliftend op de stand: dit antwoord haalt per traject kenteken en plaatsen op en wordt
 * precies één keer nodig, terwijl de stand elke paar seconden langskomt bij élke ingelogde planner.
 */
export const getPlanRunSummary = async (planRunId: number) => {
    return await apiHttpClient().get<PlanRunSummary>(`${ENDPOINT_GET_PLAN_RUN_SUMMARY}?planRunId=${planRunId}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

/**
 * Controleert een voorgenomen plan-run vóór verzenden. Zonder centrale foutafhandeling: de uitkomst is een
 * antwoord waar de dialoog zelf iets mee doet, geen fout die de gebruiker als melding hoort te zien.
 */
export const checkPlanRun = async (trajectoryIds: number[], transportVehicleIds: number[]) => {
    return await apiHttpClient(false).post<PlanRunCheck>(ENDPOINT_CHECK_PLAN_RUN, {
        trajectoryIds: trajectoryIds,
        transportVehicleIds: transportVehicleIds
    })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}

/**
 * Breekt een lopende plan-run af. Zonder centrale foutafhandeling: de voortgangsweergave vertelt zelf wat er
 * gebeurde, in bewoordingen die over de plan-run gaan in plaats van over een mislukte aanroep.
 */
export const cancelPlanRun = async (planRunId: number) => {
    return await apiHttpClient(false).post<CancelPlanRunResponse>(ENDPOINT_CANCEL_PLAN_RUN, {
        planRunId: planRunId
    })
        .then(response => {
            return response;
        })
        .catch(error => {
            return error;
        })
}
